export function toDate(value) {
  if (!value) return null;
  if (typeof value?.toDate === 'function') return value.toDate();
  if (value instanceof Date) return value;
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function formatDate(value, fallback = '—') {
  const date = toDate(value);
  return date ? date.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' }) : fallback;
}

export function formatDateTime(value, fallback = '—') {
  const date = toDate(value);
  return date ? date.toLocaleString('en-IN', { dateStyle: 'medium', timeStyle: 'short' }) : fallback;
}

export function currency(value = 0) {
  return `₹${Number(value || 0).toLocaleString('en-IN')}`;
}

export function asInt(value) {
  if (String(value).toLowerCase() === 'unlimited') return 999;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? Math.trunc(parsed) : 0;
}

export function screenLimitLabel(value) {
  const n = asInt(value);
  return n >= 999 ? 'Unlimited' : String(n);
}

export function bytesToSize(bytes = 0) {
  if (!bytes) return '0 B';
  const units = ['B', 'KB', 'MB', 'GB', 'TB'];
  const index = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), units.length - 1);
  return `${(bytes / 1024 ** index).toFixed(index > 1 ? 1 : 0)} ${units[index]}`;
}

export function onlineFromLastSeen(value, thresholdMs = 60000) {
  const date = toDate(value);
  return Boolean(date && Date.now() - date.getTime() < thresholdMs);
}

export function slug(value = '') {
  return String(value).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
}
